import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'product_permission',
    standalone: false
})
export class ProductPermissionPipe implements PipeTransform {
  transform(roles: Array<string> | undefined, product: string): boolean {
    return false;
  }
}
